// 開發用 debug 日誌：production build（import.meta.env.DEV = false）一律靜默，
// 開發時可用 VITE_DEBUG_LOGS=false 關閉
const DEBUG_ENABLED = import.meta.env.DEV && import.meta.env.VITE_DEBUG_LOGS !== 'false'

export function debugLog(...args: unknown[]) {
  if (DEBUG_ENABLED) {
    console.log(...args)
  }
}
